import { Typography, Tag } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import TrustCenterCard from "./TrustCenterCard";

const { Title, Paragraph } = Typography;
export default function ControlCard({ control }) {
  // const [isTruncated, setIsTruncated] = useState(false);
  // const textRef = useRef < HTMLDivElement > null;

  const cleanDescriptionDisplay = (text) => {
    const parts = text.split(/(\[[\s\w-]+\])/g);

    return parts.map((part, index) => {
      if (part.match(/^\[[\s\w-]+\]$/)) {
        return (
          <span key={index} style={{ whiteSpace: "nowrap" }}>
            {part}
          </span>
        );
      }
      return part;
    });
  };

  // useEffect(() => {
  //   const checkTruncation = () => {
  //     const element = textRef?.current?.querySelector(".ant-typography");
  //     if (textRef.current && element) {
  //       setIsTruncated(element.scrollHeight > element.clientHeight);
  //     }
  //   };

  //   checkTruncation();
  //   window.addEventListener("resize", checkTruncation);
  //   return () => window.removeEventListener("resize", checkTruncation);
  // }, [control.description]);

  const textContent = (
    <Paragraph
      ellipsis={{
        rows: 6,
        tooltip: false,
      }}
      style={{
        color: "#666",
        fontSize: "14px",
        margin: 0,
        lineHeight: "1.75",
      }}
    >
      {cleanDescriptionDisplay(control.description)}
    </Paragraph>
  );

  return (
    <TrustCenterCard
      style={{
        border: "1px solid #e4e7ec",
      }}
      bodyStyle={{
        padding: "24px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          marginBottom: "12px",
          flexShrink: 0, // Prevent shrinking
        }}
      >
        <Title level={4} style={{ margin: 0 }}>
          {control.id}
        </Title>
        <Tag
          icon={<CheckCircleOutlined />}
          color="success"
          style={{
            backgroundColor: "#f6ffed",
            borderColor: "#b7eb8f",
            color: "#52c41a",
          }}
        >
          Pass
        </Tag>
      </div>
      <div style={{ flex: 1, overflow: "hidden" }}>
        {/* {isTruncated ? (
          <Tooltip title={control.description} placement="bottom">
            {textContent}
          </Tooltip>
        ) : (
          textContent
        )} */}
        {textContent}
      </div>
    </TrustCenterCard>
  );
}
